export default __webpack_public_path__ + "static/media/Highland_Front.b9334d87.png";